import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@prima-afp/prima-ui-design-system/dist/ui-components";


const TOCDescription = ({timerToStartValidation}) => {
  return (
    <Typography
      align="center"
      bold
      color="#4E5258"
      variant="h4"
    >
      ¡Prepárate! Iniciamos en <span style={{ color: "#04A6A2" }}>{timerToStartValidation} segundos</span>
    </Typography>
  );
};

const StartValidationDescription = ({ timerToStartValidation }) => {
  return  <TOCDescription timerToStartValidation={timerToStartValidation}/>;
};

StartValidationDescription.propTypes = {
  isOtherflow: PropTypes.bool,
};

StartValidationDescription.defaultProps = {
  isOtherflow: false,
};

export default StartValidationDescription;
